import { Component, EventEmitter, Input, Output } from '@angular/core';
import { isImage, isPDF } from 'src/app/shared/utils/file';

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss']
})
export class DocumentPreviewComponent {
  @Input() selectedDocument: string = null;
  @Output() closed = new EventEmitter<void>();

  panelWidth = 500;
  zoomLevel = 1;
  rotation = 0;
  isPDF = isPDF;
  isImage = isImage;

  rotateImage(event: MouseEvent): void {
    event.stopPropagation();
    this.rotation = (this.rotation + 90) % 360;
  }

  startResize(event: MouseEvent, direction: 'horizontal' | 'vertical' = 'horizontal'): void {
    event.preventDefault();
    event.stopPropagation();

    const startX = event.clientX;
    const startY = event.clientY;
    const startWidth = this.panelWidth;
    const startHeight = (event.target as HTMLElement).closest('.dock-panel')?.clientHeight || 0;
    let resizing = true;

    document.body.style.userSelect = 'none';
    document.body.style.cursor = direction === 'horizontal' ? 'ew-resize' : 'ns-resize';

    const onMouseMove = (moveEvent: MouseEvent) => {
      if (!resizing) return;
      if (direction === 'horizontal') {
        const delta = startX - moveEvent.clientX;
        const newWidth = startWidth + delta;
        if (newWidth >= 350 && newWidth <= window.innerWidth * 0.9) {
          this.panelWidth = newWidth;
        }
      } else {
        const deltaY = moveEvent.clientY - startY;
        const newHeight = startHeight - deltaY;
        const container = (event.target as HTMLElement).closest('.dock-panel') as HTMLElement;
        if (container && newHeight >= 200 && newHeight <= window.innerHeight * 0.95) {
          container.style.height = `${newHeight}px`;
        }
      }
    };

    const onMouseUp = () => {
      resizing = false;
      document.body.style.userSelect = 'auto';
      document.body.style.cursor = 'default';
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  }
  
  zoomIn(event: MouseEvent): void {
    event.stopPropagation();
    this.zoomLevel = Math.min(this.zoomLevel + 0.1, 5);
  }

  zoomOut(event: MouseEvent): void {
    event.stopPropagation();
    this.zoomLevel = Math.max(this.zoomLevel - 0.1, 0.2);
  }

  resetZoom(event: MouseEvent): void {
    event.stopPropagation();
    this.zoomLevel = 1;
  }

  onWheelZoom(event: WheelEvent): void {
    event.preventDefault();
    this.zoomLevel += event.deltaY < 0 ? 0.1 : -0.1;
    this.zoomLevel = Math.min(Math.max(this.zoomLevel, 0.2), 5);
  }

  closePreview(): void {
    this.rotation = 0;
    this.zoomLevel = 1;
    this.closed.emit(); 
  }
}
